import * as React from 'react';
import configData from "../../../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button, CustomInput,
    Modal, ModalBody, ModalFooter,
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardCuentaBancaria from "components/Varios/CardCuentaBancaria.js";

//import FileUpload from "components/Varios/FileUpload.js";
//import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import ModalFirmarPDFAcuerdo from 'components/Varios/Modals/ModalFirmarPDFAcuerdo';

import { authenticationService } from '../../../services/authentication.service';

const id = 1043;
const API_URL = configData.SERVER_URL;

export class CuentaBancariaData {
    idcuentabancaria: number = 0;
    idpersona: number = 0;

    codBanco: string = "";
    strBanco: string = "";
    tipocuenta: number = 0;
    strTipoCuenta: string = "";
    nrocuenta: string = "";
    refarchivo: string = "";
    fecharegistro?: string = "";
    estado: string = "";
    estadorevisionth: number = 0;
    strEstado: string = "";
    idotrosdocumentos: number = 0;
}

interface DatosBancariosDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: CuentaBancariaData;
    CuentaBancariaList: CuentaBancariaData[];
    bancosList: Array<any>;
    tipocuentasList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
    isOpen: boolean;
    urlPDF: string;
    loadingPDF: boolean;
    isOpenModal: boolean;
    acuerdomedios: boolean;
    AcuerdoMediosElectronicosList: Array<any>;
}

export class DatosBancarios extends React.Component<RouteComponentProps, DatosBancariosDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new CuentaBancariaData(),
            CuentaBancariaList: [], bancosList: [], tipocuentasList: [], error: null, tiposEvidencia: [], filesData: [], isOpen: false,
            urlPDF: "", loadingPDF: false, isOpenModal: false, acuerdomedios: false, AcuerdoMediosElectronicosList: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarCuentaBancaria = this.cargarCuentaBancaria.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
        this.cargarDatos = this.cargarDatos.bind(this);
        this.onChangeAlphaNumericInput = this.onChangeAlphaNumericInput.bind(this);
    }

    componentDidMount() {
        window.location.href = "https://th.espol.edu.ec/user/informacion-laboral/pagos";
        //authenticationService.currentUser.subscribe(
        //    (x) => {
        //        this.setState({
        //            currentUser: x
        //        });
        //        if (x && x.token) {
        //            this.cargarDatos();
        //            this.cargarCuentaBancaria();
        //            this.cargarAcuerdoMedios();
        //        }
        //    }
        //);
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        fetch(API_URL + "CuentaBancaria/Bancos")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            bancosList: result.entTabla.map(d => ({
                                "value": d.codBanco.trim(),
                                "label": d.nombreBanco
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los bancos.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        bancosList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        fetch(API_URL + "CuentaBancaria/CuentaBancariaCatalogo/TIPO DE CUENTA")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipocuentasList: result.entTabla.map(d => ({
                                "value": d.idcatalogo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los tipos de cuenta.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tipocuentasList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarCuentaBancaria() {
        this.setState({
            loading: false,
            loadingList: false
        });
        fetch(API_URL + "CuentaBancaria/CuentaBancariaDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            CuentaBancariaList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(filesData)
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los datos bancarios.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        CuentaBancariaList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({
            dtoData: dto,
        });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });

    }

    cargarEvidencias(filesData: any[]) {
        var tiposEvidencia = [
            { "value": "IDI", "label": "Documento cuenta bancaria" + filesData.filter(f => f.type == "IDI").map(ff => ': ' + ff.file.name).join(', ') },
        ];
        return tiposEvidencia;
    }

    descargarEvidencias(cuentabancaria: CuentaBancariaData) {
        var evidencias = new Array();
        if (cuentabancaria.refarchivo) {
            evidencias.push({ name: "CUENTA-" + this.state.currentUser.identificacion + "-" + cuentabancaria.strBanco.trim() + ".PDF", url: API_URL + "CuentaBancaria/Refarchivo/" + cuentabancaria.idcuentabancaria });
        }
        return evidencias;
    }
    descargarSolicitud(cuentabancaria: CuentaBancariaData) {
        var evidencias = new Array();
        if (cuentabancaria.idotrosdocumentos) {
            evidencias.push({ name: "SOLICITUD-" + this.state.currentUser.identificacion + "-" + cuentabancaria.strBanco.trim() + ".PDF", url: API_URL + "CuentaBancaria/RefarchivoSolicitud/" + cuentabancaria.idotrosdocumentos });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new CuentaBancariaData() });
    }

    onClickEdit(idcuentabancaria) {
        this.setState({
            dtoData: new CuentaBancariaData()
        });

        fetch(API_URL + "CuentaBancaria/CuentaBancariaById/" + idcuentabancaria)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(filesData),
                            loading: false
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"]);
                    }

                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        dtoData: new CuentaBancariaData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idcuentabancaria) {
        fetch(API_URL + "CuentaBancaria/DeleteCuentaBancariaPersona/" + idcuentabancaria, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"]);
                    }
                    else {
                        alertService.success("Se anuló el registro correctamente.");
                        this.cargarCuentaBancaria();
                    }
                })
    }

    private postFiles(postFilesUrl, filesData, identidad) {
        if (filesData.length > 0) {
            var formFilesData = new FormData();

            filesData.map((fileData) => {
                formFilesData.append("files", fileData.file, fileData.file.name);
            });

            formFilesData.append('identidad', identidad);

            fetch(API_URL + postFilesUrl, {
                method: 'POST',
                body: formFilesData
            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error("Ocurrió un error al guardar la evidencia.");
                        }
                        else if (responseJson["strEstado"] === "S") {

                            this.cargarCuentaBancaria();
                        }
                    },
                    (error) => { alertService.error("Ocurrió un error al cargar las evidencias.") }
                );
        }
    }

    private handleSave() {
        //event.preventDefault();
        //const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        if (filesData === undefined || filesData.length === 0) {
            alertService.error("Debe adjuntar evidencia de la cuenta bancaria. ");
            return;
        }

        /*forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;
        });*/

        if (!dto.codBanco) {
            formIsValid = false;
            errors += "Seleccione la entidad bancaria \n";
        }
        if (!dto.tipocuenta) {
            formIsValid = false;
            errors += "Seleccione el tipo de cuenta \n";
        }
        if (!dto.nrocuenta) {
            formIsValid = false;
            errors += "Ingrese el número de cuenta \n";
        }

        dto.idpersona = this.state.currentUser.idpersona;
        delete dto['fecharegistro'];

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (!this.state.acuerdomedios) {
            formIsValid = false;
            errors += "Debe de registrar el documento de 'Acuerdo de Responsabilidad de Uso de Medios Electrónicos' en sus Datos personales. \n";
        }

        if (formIsValid) {
            var btnGuardar = document.getElementById("btnGuardar");
            const i = document.createElement("i");
            i.setAttribute("id", "loadingEnviar")
            i.setAttribute("class", "fa fa-spin fa-spinner")
            if (btnGuardar != null) {
                btnGuardar.textContent = " Cargando . . . ";
                btnGuardar.insertBefore(i, null)
                btnGuardar.setAttribute("disabled", "true");
            }

            if (dto.idcuentabancaria === 0) {
                fetch(API_URL + "CuentaBancaria/PostCuentaBancariaPersona", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error("Ocurrió un error: " + responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La cuenta bancaria se ha registrado correctamente.");

                                this.postFiles("CuentaBancaria/PostFiles", filesData, responseJson.entidad.idcuentabancaria);

                                this.onClickLimpiar();
                                this.cargarCuentaBancaria();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson["strMensaje"])
                            }
                            this.setState({
                                urlPDF: "",
                                isOpenModal: false,
                            });
                            var loadingEnviar = document.getElementById("loadingEnviar");
                            if (loadingEnviar != null) {
                                var parentNode = loadingEnviar.parentNode;
                                if (parentNode != null) {
                                    parentNode.removeChild(loadingEnviar);
                                }
                            }
                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "CuentaBancaria/PutCuentaBancariaPersona", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La cuenta bancaria se ha actualizado correctamente.");

                                this.postFiles("CuentaBancaria/PostFiles", filesData, responseJson.entidad.idcuentabancaria);

                                this.onClickLimpiar();
                                this.cargarCuentaBancaria();

                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson);
                            }

                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error);
                        }
                    )


            }

            var btnVistaPrevia = document.getElementById("btnGuardar");
            if (btnVistaPrevia != null) {
                btnVistaPrevia.textContent = "Aceptar";
                btnVistaPrevia.removeAttribute("disabled");
            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }

    }

    toggle = () => {
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        if (filesData === undefined || filesData.length === 0) {
            formIsValid = false;
            errors += "Debe adjuntar evidencia de la cuenta bancaria. <br />";
        }
        if (!dto.codBanco) {
            formIsValid = false;
            errors += "Seleccione la entidad bancaria. <br />";
        }
        if (!dto.tipocuenta) {
            formIsValid = false;
            errors += "Seleccione el tipo de cuenta. <br />";
        }
        if (!dto.nrocuenta) {
            formIsValid = false;
            errors += "Ingrese el número de cuenta. <br />";
        }
        if (!formIsValid) {
            alertService.error("Ocurrió un error: " + errors);
            this.setState({
                isOpen: false,
            });
        }
        else {
            this.setState({
                isOpen: !this.state.isOpen,
            });
        }
    };

    cargarAcuerdoMedios() {
        this.setState({
            loading: false,
            loadingList: false
        });
        fetch(API_URL + "AcuerdoMediosElectronicos/AcuerdoMediosElectronicosDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            acuerdomedios: result.entTabla.length > 0 ? true : false
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los datos.");
                    }
                },
                (error) => {
                    alertService.error("Ocurrió un error: " + error);
                }
            )
    }

    vistaPrevia(key) {

        if (key === "VistaPrevia") {
            alertService.clear();

            var dto = this.state.dtoData;

            var filesData = this.state.filesData;
            let formIsValid = true;
            let errors = "";

            if (filesData === undefined || filesData.length === 0) {
                formIsValid = false;
                errors += "Debe adjuntar evidencia de la cuenta bancaria. <br />";
            }
            if (!dto.codBanco) {
                formIsValid = false;
                errors += "Seleccione la entidad bancaria. <br />";
            }
            if (!dto.tipocuenta) {
                formIsValid = false;
                errors += "Seleccione el tipo de cuenta. <br />";
            }
            if (!dto.nrocuenta) {
                formIsValid = false;
                errors += "Ingrese el número de cuenta. <br />";
            }
            if (!this.state.acuerdomedios) {
                formIsValid = false;
                errors += "Debe de registrar el documento de 'Acuerdo de Responsabilidad de Uso de Medios Electrónicos' en sus Datos personales. <br />";
            }

            if (!formIsValid) {
                alertService.error("Ocurrió un error: " + errors);
                this.setState({
                    isOpenModal: false,
                });
            }
            else {
                const data = JSON.stringify({
                    "idpersona": this.state.currentUser.idpersona,
                    "codBanco": this.state.dtoData.codBanco,
                    "tipocuenta": this.state.dtoData.tipocuenta,
                    "nrocuenta": this.state.dtoData.nrocuenta
                });

                var btnVistaPrevia = document.getElementById("btnVistaPrevia");
                const i = document.createElement("i");
                i.setAttribute("id", "loadingEnviar")
                i.setAttribute("class", "fa fa-spin fa-spinner")
                if (btnVistaPrevia != null) {
                    btnVistaPrevia.textContent = " Cargando . . . ";
                    btnVistaPrevia.insertBefore(i, null)
                    btnVistaPrevia.setAttribute("disabled", "true");
                }

                fetch(API_URL + "CuentaBancaria/VistaPrevia", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => {
                        if (response.status !== 200) {
                            alertService.error("Ha ocurrido un evento inesperado al momento de generar la vista previa.");
                            this.setState({ isOpenModal: false });
                            return
                        }

                        response.blob()
                            .then(blob => {
                                let url = window.URL.createObjectURL(blob);

                                var loadingEnviar = document.getElementById("loadingEnviar");
                                if (loadingEnviar != null) {
                                    var parentNode = loadingEnviar.parentNode;
                                    if (parentNode != null) {
                                        parentNode.removeChild(loadingEnviar);
                                    }
                                }
                                var btnVistaPrevia = document.getElementById("btnVistaPrevia");
                                if (btnVistaPrevia != null) {
                                    btnVistaPrevia.textContent = "Vista Previa";
                                    btnVistaPrevia.removeAttribute("disabled");
                                }

                                this.setState({ urlPDF: url, isOpenModal: true });

                            });
                    }
                    )
            }

        }
    }

    onChangeAlphaNumericInput(event) {
        const value = event.target.value;
        const regex = /^[0-9a-zA-Z(\)]+$/;
        if (value.match(regex) || value === "") {
            var dto = this.state.dtoData;
            dto[event.target.name] = event.target.value.toUpperCase();
            this.setState({
                dtoData: dto,
                loading: false
            });
        }
    }

    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.CuentaBancariaList, this.state.bancosList, this.state.tipocuentasList, this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(CuentaBancariaList: Array<any>, bancosList: Array<any>, tipocuentasList: Array<any>, tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Registro / Actualización de Cuenta Bancaria</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave}>
                                        <Row form>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="codBanco">Entidad Financiera*</Label>
                                                    <SelectItem
                                                        options={bancosList}
                                                        value={this.state.dtoData.codBanco}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="codBanco"
                                                        id="codBanco"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Label for="tipocuenta">Tipo de Cuenta*</Label>
                                                <SelectItem
                                                    options={tipocuentasList}
                                                    value={this.state.dtoData.tipocuenta}
                                                    onChange={this.handleSelectChange}
                                                    placeholder=""
                                                    name="tipocuenta"
                                                    id="tipocuenta"
                                                    icon="fa-caret-right"
                                                />
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="nrocuenta">Número de cuenta*</Label>
                                                    <Input maxLength="25" type="text" name="nrocuenta" id="nrocuenta" value={this.state.dtoData.nrocuenta} onChange={this.onChangeAlphaNumericInput} onInput={(e) => {
                                                        if (e.target.value.length > e.target.maxLength)
                                                            e.target.value = e.target.value.slice(0, e.target.maxLength);
                                                    }} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Label for="fechagraduacion">Evidencia*</Label>
                                                <FormGroup row>
                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="CUENTA"
                                                            placeholder={this.state.dtoData.refarchivo ? "Actualizar documento cuenta bancaria" : "Subir Documento"} />
                                                    </Col>
                                                    <InputFileDownload tipo="documento cuenta bancaria"
                                                        id="downloadRef"
                                                        refarchivo={this.state.dtoData.refarchivo}
                                                        name={"CUENTA" + this.state.currentUser.identificacion + "-" + this.state.dtoData.codBanco + ".PDF"}
                                                        url={API_URL + "CuentaBancaria/Refarchivo/" + this.state.dtoData.idcuentabancaria}
                                                    />
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                        <Row>
                                            <Col md={12}>
                                                <p>
                                                    Declaro bajo juramento, la autenticidad, veracidad y exactitud de la información que he proporcionado a la Institución, a fin de que los ingresos por remuneración y/u honorarios sean acreditados en la cuenta indicada.
                                                </p>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    {/*<Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>*/}
                                                    {/*<Button color="secondary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.toggle()}>Guardar</Button>*/}
                                                    <Button id="btnVistaPrevia" color="secondary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.vistaPrevia("VistaPrevia")}>Vista Previa</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </form>
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {CuentaBancariaList.map((dto, index) =>
                                                <CardCuentaBancaria
                                                    key={dto.idcuentabancaria}
                                                    objeto={dto}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    evidenciaSolicitud={this.descargarSolicitud(dto)}
                                                    number={(index + 1) + " / " + CuentaBancariaList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idcuentabancaria)}
                                                    eventDelete={() => this.onClickDelete(dto.idcuentabancaria)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <ModalFirmarPDFAcuerdo
                    show={(this.state.urlPDF !== undefined && this.state.urlPDF !== "") || this.state.loadingPDF}
                    tituloModal='Registro / Actualización de Cuenta Bancaria'
                    admiteFirmaElectronica={this.state.acuerdomedios}
                    admiteFirmaFisica={!this.state.acuerdomedios}
                    size="xl"
                    urlArchivo={this.state.urlPDF}
                    onClose={() => this.setState({ urlPDF: "" })}
                    cargandoDatos={this.state.loadingPDF}
                    onClickFirmaAcuerdo={async () => await this.handleSave()}

                />

            </>
        );
    }
}

export default DatosBancarios;